import React, { useState, useEffect } from 'react';
import { statsData } from '../../data/data_stats.js';
import './StatsDashboard.css';

function StatsDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        
        if (!statsData || !statsData.getStats) {
          throw new Error('statsData or getStats function is not available');
        }
        
        const response = await statsData.getStats();
        
        if (response.success) {
          setStats(response.stats);
        } else {
          setError('Failed to load statistics');
        }
      } catch (err) {
        setError('Error loading statistics');
        console.error('Error fetching stats:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <div className="stats-dashboard">
        <div className="stats-loading">
          <div className="loading-spinner"></div>
          <p>Loading system statistics...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="stats-dashboard">
        <div className="stats-error">
          <i className="ti ti-alert-circle"></i>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  return (
    <div className="stats-dashboard">
      <div className="stats-header">
        <h2>System Statistics</h2>
        <p>Real-time overview of platform activity</p>
      </div>

      <div className="stats-grid">
        {/* Meeting Activity Group */}
        <div className="stats-group">
          <h3 className="group-title">
            <i className="ti ti-calendar-event"></i>
            Meeting Activity
          </h3>
          <div className="stats-cards">
            <div className="stat-card primary">
              <div className="stat-icon">
                <i className="ti ti-check"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.totalCompletedInstances}</div>
                <div className="stat-label">Total Completed</div>
              </div>
            </div>
            <div className="stat-card success">
              <div className="stat-icon">
                <i className="ti ti-calendar-check"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.totalCompletedInstancesLast30Days}</div>
                <div className="stat-label">Last 30 Days</div>
              </div>
            </div>
            <div className="stat-card warning">
              <div className="stat-icon">
                <i className="ti ti-clock"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.totalInstancesInProgress}</div>
                <div className="stat-label">In Progress</div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Management Group */}
        <div className="stats-group">
          <h3 className="group-title">
            <i className="ti ti-files"></i>
            Content Management
          </h3>
          <div className="stats-cards">
            <div className="stat-card info">
              <div className="stat-icon">
                <i className="ti ti-file-text"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.totalActiveTemplates}</div>
                <div className="stat-label">Active Templates</div>
              </div>
            </div>
            <div className="stat-card purple">
              <div className="stat-icon">
                <i className="ti ti-message-circle"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.totalActivePromptSets}</div>
                <div className="stat-label">Active Prompt Sets</div>
              </div>
            </div>
            <div className="stat-card teal">
              <div className="stat-icon">
                <i className="ti ti-script"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.totalActiveScripts}</div>
                <div className="stat-label">Active Scripts</div>
              </div>
            </div>
          </div>
        </div>

        {/* User Activity Group */}
        <div className="stats-group">
          <h3 className="group-title">
            <i className="ti ti-users"></i>
            User Activity
          </h3>
          <div className="stats-cards">
            <div className="stat-card secondary">
              <div className="stat-icon">
                <i className="ti ti-user-check"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.totalActiveUsers}</div>
                <div className="stat-label">Total Active Users</div>
              </div>
            </div>
            <div className="stat-card orange">
              <div className="stat-icon">
                <i className="ti ti-user-star"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.totalActiveUsersLast30Days}</div>
                <div className="stat-label">Active Last 30 Days</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {stats.timestamp && (
        <div className="stats-footer">
          <p>Last updated: {new Date(stats.timestamp).toLocaleString()}</p>
        </div>
      )}
    </div>
  );
}

export default StatsDashboard; 